import { styled } from "@mui/system";
import { colors } from "../../../../../utils";
// import styled MuiStyled from "styled-components";

export const CardContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "100%",
  height: "39vh",
  padding: "10px 16px",
  boxSizing: "border-box",
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
  position: "relative",
  overflow: "hidden",
});

export const TopSection = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ProfileImageWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const ProfileImage = styled("img")({
  width: "72px",
  height: "72px",
  borderRadius: "50%",
});

export const ProfileImageInnerWrapper = styled("div")({
  display: "flex",
});

export const TextWrapper = styled("div")({
  padding: "12px 16px",
});
export const DescriptionWrapper = styled("div")({
  height: 40,
  width: 40,
  backgroundColor: colors.background,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 20,
  cursor: "pointer",
});

export const ProfileInfo = styled("div")({
  paddingTop: 10,
});

export const IconWrapper = styled("div")({
  // display: "grid",
  // gridTemplateColumns: "repeat(5)",
  // gap: 15,
  display: "flex",
  gap: 15,
  justifyContent: "center",
});

export const Divider = styled("div")({
  width: "100%",
  height: "1px",
  backgroundColor: colors.divider,
  //   margin: "20px 0",
});

export const FolderTileContainer = styled("div")(
  ({ showCursor, isSelected }) => ({
    // height: "7vh",
    padding: "10px 8px",
    borderRadius: 4,
    border: `1px solid ${colors.lightBorder}`,
    display: "flex",
    justifyContent: "space-between",
    boxSizing: "border-box",
    backgroundColor: isSelected ? colors.Highlight : colors.NeutralBackground,
    alignItems: "center",
    // cursor: showCursor && "pointer",
    cursor: "pointer",
    userSelect: "none",
  })
);

export const ToolTipStyled = styled("div")({
  marginLeft: 10,
  marginTop: 8,
  width: 20,
  height: 20,
  borderRadius: "50%",
  border: "1px solid black",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "black",
  fontSize: 14,
  fontWeight: "bold",
  cursor: "pointer",
});
